import { ReactNode } from 'react';
import { FieldValues, Path, useWatch } from 'react-hook-form';

export type WatchValuesProps<TFieldValues extends FieldValues = FieldValues> = {
  names: Path<TFieldValues>[];
  children: (values: any[]) => ReactNode;
};

/**
 * Subscribes to @param names and renders @param children with the watched values.
 * Keeps render-time field values reactive without reading `getValues()` during render.
 */
export function WatchValues<TFieldValues extends FieldValues = FieldValues>({
  names,
  children
}: WatchValuesProps<TFieldValues>) {
  const values = useWatch({ name: names }) as any[];

  return <>{children(values)}</>;
}
